import { Injectable } from '@angular/core'

import { SerieProposalItem } from './serie-proposal-item'

@Injectable()
export class SerieProposalItemSerializer {
  fromJson(json: any): SerieProposalItem {
    const serieProposalItem = json

    return serieProposalItem
  }

  toJson(serieProposalItem: SerieProposalItem): any {
    return {
      ...serieProposalItem
    }
  }
}
